(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-featured-collection"] && !Shopify.designMode) return;
  try {
    
 $(document).ready(function(){
  var $carousel = $(".cusProductGrid");

    $carousel.owlCarousel({
      items: 1,
      loop: true,
      nav: true,
      dots: false,
      navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M6.64645 13.3496C6.84171 13.5449 7.15829 13.5449 7.35355 13.3496C7.54882 13.1544 7.54882 12.8378 7.35355 12.6425L6.64645 13.3496ZM1 6.99609L0.646447 6.64254C0.451184 6.8378 0.451184 7.15438 0.646447 7.34964L1 6.99609ZM7.35355 1.34969C7.54882 1.15439 7.54882 0.837794 7.35355 0.642494C7.15829 0.447294 6.84171 0.447294 6.64645 0.642494L7.35355 1.34969ZM7.35355 12.6425L1.35355 6.64254L0.646447 7.34964L6.64645 13.3496L7.35355 12.6425ZM1.35355 7.34964L7.35355 1.34969L6.64645 0.642494L0.646447 6.64254L1.35355 7.34964Z" fill="#404040"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1.35355 13.3496C1.15829 13.5449 0.84171 13.5449 0.64645 13.3496C0.45118 13.1544 0.45118 12.8378 0.64645 12.6425L1.35355 13.3496ZM7 6.99609L7.35355 6.64254C7.54882 6.8378 7.54882 7.15438 7.35355 7.34964L7 6.99609ZM0.646451 1.34969C0.451181 1.15439 0.451181 0.837794 0.646451 0.642494C0.841711 0.447294 1.15829 0.447294 1.35355 0.642494L0.646451 1.34969ZM0.64645 12.6425L6.64645 6.64254L7.35355 7.34964L1.35355 13.3496L0.64645 12.6425ZM6.64645 7.34964L0.646451 1.34969L1.35355 0.642494L7.35355 6.64254L6.64645 7.34964Z" fill="#404040"/></svg>'],
      autoplay: false,
      autoplayHoverPause: true,
      responsive: {
        0: { items: 1.3, margin: 20 },
        500: { items: 2, margin: 20 }, 
        768: { items: 2, margin: 30 }, 
        1200: { items: 3, margin: 40 } 
      }
  });

  // Run once immediately
  fixOwlButtons($carousel);

  // Run again on refresh
  $carousel.on("refreshed.owl.carousel", function () {
    fixOwlButtons($(this));
  });

  function fixOwlButtons($el) {
    setTimeout(function () {
      $el.find(".owl-prev, .owl-next")
        .removeAttr("role")
        .attr("aria-label", function () {
          return $(this).hasClass("owl-prev") ? "Previous slide" : "Next slide";
        });
    }, 0);
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-image-slideshow"] && !Shopify.designMode) return;
  try {
    
//  $(document).ready(function(){
//   $('.customimageSlideshow').owlCarousel({
//         loop:true,
//         nav:true,
//         dots:false,
//         navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M6.64645 13.3496C6.84171 13.5449 7.15829 13.5449 7.35355 13.3496C7.54882 13.1544 7.54882 12.8378 7.35355 12.6425L6.64645 13.3496ZM1 6.99609L0.646447 6.64254C0.451184 6.8378 0.451184 7.15438 0.646447 7.34964L1 6.99609ZM7.35355 1.34969C7.54882 1.15439 7.54882 0.837794 7.35355 0.642494C7.15829 0.447294 6.84171 0.447294 6.64645 0.642494L7.35355 1.34969ZM7.35355 12.6425L1.35355 6.64254L0.646447 7.34964L6.64645 13.3496L7.35355 12.6425ZM1.35355 7.34964L7.35355 1.34969L6.64645 0.642494L0.646447 6.64254L1.35355 7.34964Z" fill="#404040"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1.35355 13.3496C1.15829 13.5449 0.84171 13.5449 0.64645 13.3496C0.45118 13.1544 0.45118 12.8378 0.64645 12.6425L1.35355 13.3496ZM7 6.99609L7.35355 6.64254C7.54882 6.8378 7.54882 7.15438 7.35355 7.34964L7 6.99609ZM0.646451 1.34969C0.451181 1.15439 0.451181 0.837794 0.646451 0.642494C0.841711 0.447294 1.15829 0.447294 1.35355 0.642494L0.646451 1.34969ZM0.64645 12.6425L6.64645 6.64254L7.35355 7.34964L1.35355 13.3496L0.64645 12.6425ZM6.64645 7.34964L0.646451 1.34969L1.35355 0.642494L7.35355 6.64254L6.64645 7.34964Z" fill="#404040"/></svg>'],
//         responsive: {
//             0: { items: 1.2, margin:20},
//             500: { items: 1.3, margin:20, stagePadding: 50 }, 
//             768: { items: 2, margin:20, stagePadding: 50 }, 
//             1200: { items:3, margin:0,} 
//         }
        
//     })
//  })
  $(document).ready(function(){
  var $carousel = $(".customimageSlideshow");

    $carousel.owlCarousel({
       loop:true,
        nav:true,
        dots:false,
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M6.64645 13.3496C6.84171 13.5449 7.15829 13.5449 7.35355 13.3496C7.54882 13.1544 7.54882 12.8378 7.35355 12.6425L6.64645 13.3496ZM1 6.99609L0.646447 6.64254C0.451184 6.8378 0.451184 7.15438 0.646447 7.34964L1 6.99609ZM7.35355 1.34969C7.54882 1.15439 7.54882 0.837794 7.35355 0.642494C7.15829 0.447294 6.84171 0.447294 6.64645 0.642494L7.35355 1.34969ZM7.35355 12.6425L1.35355 6.64254L0.646447 7.34964L6.64645 13.3496L7.35355 12.6425ZM1.35355 7.34964L7.35355 1.34969L6.64645 0.642494L0.646447 6.64254L1.35355 7.34964Z" fill="#404040"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1.35355 13.3496C1.15829 13.5449 0.84171 13.5449 0.64645 13.3496C0.45118 13.1544 0.45118 12.8378 0.64645 12.6425L1.35355 13.3496ZM7 6.99609L7.35355 6.64254C7.54882 6.8378 7.54882 7.15438 7.35355 7.34964L7 6.99609ZM0.646451 1.34969C0.451181 1.15439 0.451181 0.837794 0.646451 0.642494C0.841711 0.447294 1.15829 0.447294 1.35355 0.642494L0.646451 1.34969ZM0.64645 12.6425L6.64645 6.64254L7.35355 7.34964L1.35355 13.3496L0.64645 12.6425ZM6.64645 7.34964L0.646451 1.34969L1.35355 0.642494L7.35355 6.64254L6.64645 7.34964Z" fill="#404040"/></svg>'],
        responsive: {
            0: { items: 1.2, margin:20},
            500: { items: 1.3, margin:20, stagePadding: 50 }, 
            768: { items: 2, margin:20, stagePadding: 50 }, 
            1200: { items:3, margin:0,} 
        }
  });

  // Run once immediately
  fixOwlButtons($carousel);

  // Run again on refresh
  $carousel.on("refreshed.owl.carousel", function () {
    fixOwlButtons($(this));
  });

  function fixOwlButtons($el) {
    setTimeout(function () {
      $el.find(".owl-prev, .owl-next")
        .removeAttr("role")
        .attr("aria-label", function () {
          return $(this).hasClass("owl-prev") ? "Previous slide" : "Next slide";
        });
    }, 0);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-imagetext"] && !Shopify.designMode) return;
  try {
    
    const messages = [
    "Beautiful.",
    "Florever.",
    "Long-Lasting.",
    "Natural.",
    "Low-Maintenance."
    ];

    const textElement = document.querySelector('.customImageText h2 span');

    let currentIndex = 0;
    setInterval(() => {
    textElement.textContent = messages[currentIndex];

    currentIndex++;

    if (currentIndex >= messages.length) {
        currentIndex = 0;
    }
    }, 3000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-slideshow"] && !Shopify.designMode) return;
  try {
    
 $(document).ready(function(){
    $('.customSlideshow').owlCarousel({
      loop:true,
      margin:0,
      nav:false,
      dots:true,
      items:1,
      autoplay: true,
      autoplayTimeout: 12000,
      autoplayHoverPause: true,
      onInitialized: function(event) {
            const dots = $(event.target).find('.owl-dot');
            dots.each(function(index) {
                $(this).attr('aria-label', 'Go to slide ' + (index + 1));
            });
        }
  })
 })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
 $(document).ready(function(){
    $('.collectionSlider').owlCarousel({
      loop:true,
      margin:0,
      nav:false,
      dots:false,
      items:1,
      onInitialized: function(event) {
            const dots = $(event.target).find('.owl-dot');
            dots.each(function(index) {
                $(this).attr('aria-label', 'Go to slide ' + (index + 1));
            });
        }
  })
 })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  let lastScrollTop = 0;

  $(window).on("scroll", function () {
    let currentScroll = $(this).scrollTop();

    if (currentScroll < lastScrollTop) {
      $('.facets-vertical .facets-wrapper').css('top', '50px');
    }
    else{
       $('.facets-vertical .facets-wrapper').css('top', '20px');
    }

    lastScrollTop = currentScroll;
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rooting-for-local"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
      $(".rootingCarousel").owlCarousel({
        loop: true,
        nav: true,
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M6.64645 13.3496C6.84171 13.5449 7.15829 13.5449 7.35355 13.3496C7.54882 13.1544 7.54882 12.8378 7.35355 12.6425L6.64645 13.3496ZM1 6.99609L0.646447 6.64254C0.451184 6.8378 0.451184 7.15438 0.646447 7.34964L1 6.99609ZM7.35355 1.34969C7.54882 1.15439 7.54882 0.837794 7.35355 0.642494C7.15829 0.447294 6.84171 0.447294 6.64645 0.642494L7.35355 1.34969ZM7.35355 12.6425L1.35355 6.64254L0.646447 7.34964L6.64645 13.3496L7.35355 12.6425ZM1.35355 7.34964L7.35355 1.34969L6.64645 0.642494L0.646447 6.64254L1.35355 7.34964Z" fill="#404040"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1.35355 13.3496C1.15829 13.5449 0.84171 13.5449 0.64645 13.3496C0.45118 13.1544 0.45118 12.8378 0.64645 12.6425L1.35355 13.3496ZM7 6.99609L7.35355 6.64254C7.54882 6.8378 7.54882 7.15438 7.35355 7.34964L7 6.99609ZM0.646451 1.34969C0.451181 1.15439 0.451181 0.837794 0.646451 0.642494C0.841711 0.447294 1.15829 0.447294 1.35355 0.642494L0.646451 1.34969ZM0.64645 12.6425L6.64645 6.64254L7.35355 7.34964L1.35355 13.3496L0.64645 12.6425ZM6.64645 7.34964L0.646451 1.34969L1.35355 0.642494L7.35355 6.64254L6.64645 7.34964Z" fill="#404040"/></svg>'],
        dots:false,
        center:true,
        autoplay: false,
        responsive: {
            0: { 
              items: 1.1,
               margin: 20,
               center:false,
               stagePadding: 0,
               onChanged: function(event) {
                  $('.rootingCarousel .owl-item').find('img').css('top', '0');
                  setTimeout(function(){
                    $('.rootingCarousel .owl-item.active').first().find('img').css('top', '-30px');
                  }, 100);
                },
                onInitialize:  function(event) {
                    $('.rootingCarousel .owl-item.active').first().find('img').css('top', '-30px');
                     $('.rootingCarousel .owl-prev').attr('aria-label', 'Previous Slide');
                    $('.rootingCarousel .owl-next').attr('aria-label', 'Next Slide');
                }

             },
            520: { items: 2.3, margin: 20, stagePadding: 0 }, 
            750: { items: 2.5, margin: 32, stagePadding: 0 }, 
            1200: { items: 2.8, margin: 32, stagePadding: 0 } 
        }
      });
    
    });

  } catch(e) { console.error(e); }
})();
})();
